/* eslint-disable no-unused-vars */

import { createApp } from "vue";
import { createStore } from "vuex";
import App from "./App.vue";
import createPersistedState from "vuex-persistedstate";

const store = createStore({
  state() {
    return {
      max_width: 1200,
      max_height: 1200,
      filename_suffix: "-",
      file_quality: 1,
      use_original_file_name: false,
      include_original_file_name: false,
      password: "",
      aimodels: [
        {
          model: "microsoft/Phi-4-multimodal-instruct",
          selected: false,
        },
        {
          model: "openai/gpt-4.1",
          selected: false,
        },
        {
          model: "meta/Llama-3.2-90B-Vision-Instruct",
          selected: false,
        },
        {
          model: "meta/Llama-3.2-90B-Vision-Instruct",
          selected: false,
        },
        {
          model: "meta/Llama-3.2-11B-Vision-Instruct",
          selected: false,
        },
        {
          model: "meta/Llama-4-Scout-17B-16E-Instruct",
          selected: false,
        },
        {
          model: "meta/Llama-4-Maverick-17B-128E-Instruct-FP8",
          selected: false,
        },
      ],
    };
  },
  mutations: {
    setMaxWidth(state, max_width) {
      state.max_width = max_width;
    },
    setMaxHeight(state, max_height) {
      state.max_height = max_height;
    },
    setFileNameSuffix(state, filename_suffix) {
      state.filename_suffix = filename_suffix;
    },
    setFileQuality(state, file_quality) {
      state.file_quality = file_quality;
    },
    setUseOriginalFileName(state, use_original_file_name) {
      state.use_original_file_name = use_original_file_name;
    },
    setIncludeOriginalFileName(state, include_original_file_name) {
      state.include_original_file_name = include_original_file_name;
    },
    setPassword(state, password) {
      state.password = password;
    },
    setAiModels(state, aimodels) {
      state.aimodels = aimodels;
    },
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
});

createApp(App).use(store).mount("#app");
